// Import Firebase core
import { initializeApp } from "firebase/app";

// Import Firestore
import { getFirestore } from "firebase/firestore";

// 🔥 Your Firebase config (REPLACE WITH YOUR OWN)
const firebaseConfig = {
  apiKey: "AIzaSyCXsROa1LFmoRPaaeMvz_jkOdqFV4a9qgo",
  authDomain: "almondsoftwares1.firebaseapp.com",
  projectId: "almondsoftwares1",
  storageBucket: "almondsoftwares1.firebasestorage.app",
  messagingSenderId: "917454749562",
  appId: "1:917454749562:web:308dfae8c7f252f26160c3",
  measurementId: "G-L61R38BLR6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);